import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { DefaultOAuthInterceptor } from 'angular-oauth2-oidc';

import { SKIP_ACCESS_TOKEN } from './http-context';

/**
 * Keeps angular-oauth2-oidc token attachment semantics while exposing a modern
 * functional interceptor and HttpContext-based per-request opt-out.
 */
export const oauthAccessTokenInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.context.get(SKIP_ACCESS_TOKEN)) {
    return next(request);
  }

  return inject(DefaultOAuthInterceptor).intercept(request, { handle: next });
};
